/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomFieldPartialUpdate
 */
export interface CustomFieldPartialUpdate {
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof CustomFieldPartialUpdate
     */
    labels?: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomFieldPartialUpdate
     */
    options?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldPartialUpdate
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPartialUpdate
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldPartialUpdate
     */
    useForUploads?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldPartialUpdate
     */
    requireToUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldPartialUpdate
     */
    nonUserEditable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPartialUpdate
     */
    validation?: CustomFieldPartialUpdateValidationEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPartialUpdate
     */
    regex?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldPartialUpdate
     */
    rangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldPartialUpdate
     */
    rangeMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldPartialUpdate
     */
    numberOfDigits?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPartialUpdate
     */
    metadataPrefill?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldPartialUpdate
     */
    highlightExpiration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldPartialUpdate
     */
    multipleResponse?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldPartialUpdate
     */
    helpText?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum CustomFieldPartialUpdateValidationEnum {
    NumberOfDigits = 'number_of_digits',
    Regex = 'regex',
    Range = 'range'
}

export function CustomFieldPartialUpdateFromJSON(json: any): CustomFieldPartialUpdate {
    return CustomFieldPartialUpdateFromJSONTyped(json, false);
}

export function CustomFieldPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'labels': !exists(json, 'labels') ? undefined : json['labels'],
        'options': !exists(json, 'options') ? undefined : json['options'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'useForUploads': !exists(json, 'use_for_uploads') ? undefined : json['use_for_uploads'],
        'requireToUpload': !exists(json, 'require_to_upload') ? undefined : json['require_to_upload'],
        'nonUserEditable': !exists(json, 'non_user_editable') ? undefined : json['non_user_editable'],
        'validation': !exists(json, 'validation') ? undefined : json['validation'],
        'regex': !exists(json, 'regex') ? undefined : json['regex'],
        'rangeMin': !exists(json, 'range_min') ? undefined : json['range_min'],
        'rangeMax': !exists(json, 'range_max') ? undefined : json['range_max'],
        'numberOfDigits': !exists(json, 'number_of_digits') ? undefined : json['number_of_digits'],
        'metadataPrefill': !exists(json, 'metadata_prefill') ? undefined : json['metadata_prefill'],
        'highlightExpiration': !exists(json, 'highlight_expiration') ? undefined : json['highlight_expiration'],
        'multipleResponse': !exists(json, 'multiple_response') ? undefined : json['multiple_response'],
        'helpText': !exists(json, 'help_text') ? undefined : json['help_text'],
    };
}

export function CustomFieldPartialUpdateToJSON(value?: CustomFieldPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'labels': value.labels,
        'options': value.options,
        'name': value.name,
        'order': value.order,
        'type': value.type,
        'use_for_uploads': value.useForUploads,
        'require_to_upload': value.requireToUpload,
        'non_user_editable': value.nonUserEditable,
        'validation': value.validation,
        'regex': value.regex,
        'range_min': value.rangeMin,
        'range_max': value.rangeMax,
        'number_of_digits': value.numberOfDigits,
        'metadata_prefill': value.metadataPrefill,
        'highlight_expiration': value.highlightExpiration,
        'multiple_response': value.multipleResponse,
        'help_text': value.helpText,
    };
}


